import { render, staticRenderFns } from "./HistoricoEngrase.vue?vue&type=template&id=4fb4e03c&scoped=true"
import script from "./HistoricoEngrase.vue?vue&type=script&lang=js"
export * from "./HistoricoEngrase.vue?vue&type=script&lang=js"
import style0 from "./HistoricoEngrase.vue?vue&type=style&index=0&id=4fb4e03c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb4e03c",
  null
  
)

export default component.exports